import { ConnectedAccountType, ListType, ListViewColumn, ListViewColumnDataType } from '@/types';

interface AutopopulatedListColumn extends Pick<ListViewColumn, 'key' | 'label' | 'dataType'> {
    enriched?: boolean;
}

type AutopopulatedColumnsBySource = Partial<Record<ConnectedAccountType, AutopopulatedListColumn[]>>;

export const createRelationsListMaps = () => {
    const connectedAccountTypeToDefaultAutopopulatingColumnsPeopleMap: AutopopulatedColumnsBySource = {
        [ConnectedAccountType.GMAIL]: [
            {
                key: 'person',
                label: 'Person',
                dataType: ListViewColumnDataType.SHORT_TEXT,
                enriched: false,
            },
            {
                key: 'company',
                label: 'Company',
                dataType: ListViewColumnDataType.RELATION,
                enriched: true,
            },
            {
                key: 'title',
                label: 'Title',
                dataType: ListViewColumnDataType.SHORT_TEXT,
                enriched: true,
            },
            {
                key: 'emailAddress',
                label: 'Email Address',
                dataType: ListViewColumnDataType.EMAIL,
                enriched: false,
            },
            {
                key: 'phoneNumber',
                label: 'Phone Number',
                dataType: ListViewColumnDataType.PHONE,
                enriched: true,
            },
            {
                key: 'status',
                label: 'Status',
                dataType: ListViewColumnDataType.STATUS,
                enriched: false,
            },
            {
                key: 'connectionStrength',
                label: 'Connection Strength',
                dataType: ListViewColumnDataType.SELECT,
            },
            {
                key: 'location',
                label: 'Location',
                dataType: ListViewColumnDataType.ADDRESS,
                enriched: true,
            },
            {
                key: 'linkedin',
                label: 'LinkedIn',
                dataType: ListViewColumnDataType.URL,
                enriched: true,
            },
            {
                key: 'twitter',
                label: 'X (Twitter)',
                dataType: ListViewColumnDataType.URL,
                enriched: true,
            },
            {
                key: 'lastEmailInteraction',
                label: 'Last Email Interaction',
                dataType: ListViewColumnDataType.DATE,
                enriched: false,
            },
            {
                key: 'lastCalendarInteraction',
                label: 'Last Calendar Interaction',
                dataType: ListViewColumnDataType.DATE,
                enriched: false,
            },
            {
                key: 'nextEmailInteraction',
                label: 'Next Email Interaction',
                dataType: ListViewColumnDataType.DATE,
                enriched: false,
            },
            {
                key: 'nextCalendarInteraction',
                label: 'Next Calendar Interaction',
                dataType: ListViewColumnDataType.DATE,
                enriched: false,
            },
        ],
    };

    const connectedAccountTypeToDefaultAutopopulatingColumnsCompaniesMap: AutopopulatedColumnsBySource = {
        [ConnectedAccountType.GMAIL]: [
            {
                key: 'company',
                label: 'Company',
                dataType: ListViewColumnDataType.RELATION,
            },
            {
                key: 'description',
                label: 'Description',
                dataType: ListViewColumnDataType.LONG_TEXT,
            },
            {
                key: 'categories',
                label: 'Categories',
                dataType: ListViewColumnDataType.MULTISELECT,
            },
            {
                key: 'website',
                label: 'Website',
                dataType: ListViewColumnDataType.URL,
            },
            {
                key: 'keyContact',
                label: 'Key Contact',
                dataType: ListViewColumnDataType.RELATION,
            },
            {
                key: 'headquarters',
                label: 'Headquarters',
                dataType: ListViewColumnDataType.ADDRESS,
            },
            {
                key: 'capitalRaised',
                label: 'Capital Raised',
                dataType: ListViewColumnDataType.CURRENCY,
            },
            {
                key: 'annualRevenue',
                label: 'Annual Revenue',
                dataType: ListViewColumnDataType.CURRENCY,
            },
            {
                key: 'foundingYear',
                label: 'Founding Year',
                dataType: ListViewColumnDataType.YEAR,
            },
            {
                key: 'linkedin',
                label: 'LinkedIn',
                dataType: ListViewColumnDataType.URL,
            },
            {
                key: 'twitter',
                label: 'X (Twitter)',
                dataType: ListViewColumnDataType.URL,
            },
        ],
    };

    const connectedAccountTypeToDefaultAutopopulatingColumnsCustomMap: AutopopulatedColumnsBySource = {
        [ConnectedAccountType.GMAIL]: [
            {
                key: 'website',
                label: 'Website',
                dataType: ListViewColumnDataType.URL,
            },
            {
                key: 'description',
                label: 'Description',
                dataType: ListViewColumnDataType.LONG_TEXT,
            },
        ],
    };

    const listTypeToAutopopulatingColumnsMapMap: Record<ListType, AutopopulatedColumnsBySource> = {
        [ListType.PEOPLE]: connectedAccountTypeToDefaultAutopopulatingColumnsPeopleMap,
        [ListType.COMPANIES]: connectedAccountTypeToDefaultAutopopulatingColumnsCompaniesMap,
        [ListType.CUSTOM]: connectedAccountTypeToDefaultAutopopulatingColumnsCustomMap,
    };

    const relationsListMaps = {
        connectedAccountTypeToDefaultAutopopulatingColumnsPeopleMap,
        connectedAccountTypeToDefaultAutopopulatingColumnsCompaniesMap,
        listTypeToAutopopulatingColumnsMapMap,
    };

    return relationsListMaps;
};
